import React from "react";
import "../styles/Home.css";
import About from "./About";
import Menu from "../components/Menu";
import Event from "./Event";

function Home() {
  return (
    <div>

    <About />
    <Menu />
    <Event/>
      
    </div>
    
  );
}

export default Home;
